<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-4"><a href="#/This_Isn't_A_Game2#Contents-A">Dedication</a></p>
<p class="Body-Center para-style-override-3"><span class="Italic">To Nancy and Art</span><span class="char-style-override-1"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// This_Isnt_A_Game-3.vue?49fc8ce4